import { PermissionGate } from '@/entities/practice-member';
import { PageTitle } from '@/shared/ui/text/page-title';
import { SettingsColumn } from '@/widgets/settings/settings-column';

import { SessionNoteSettingsForEhr } from './notes-page/session-note-settings-for-ehr';
import { SessionNoteSettingsForNotes } from './notes-page/session-note-settings-for-notes';

export function NotesPage() {
    return (
        <SettingsColumn className="space-y-8">
            <PageTitle>Notes</PageTitle>
            <PermissionGate
                requiredAccessSources={['CLINICIAN', 'EHR_BASE']}
                fallback={() => <SessionNoteSettingsForNotes />}
            >
                <SessionNoteSettingsForEhr />
            </PermissionGate>
        </SettingsColumn>
    );
}
